(() => {
  function hydrateCharitable(root) {
    const source = root.querySelector('[data-charitable-directory]');
    const list = root.querySelector('[data-info-filter-list]');
    if (!source || !list) return;
    let data;
    try { data = JSON.parse(source.textContent); } catch { return; }
    if (!Array.isArray(data?.organizations)) return;
    const normalize = (text) => String(text || '').normalize('NFKC').toLocaleLowerCase().replace(/[^\p{L}\p{N}]/gu,'');
    const groups = new Map();
    const known = new Set();
    list.querySelectorAll('details').forEach((details) => {
      const label = details.querySelector('summary')?.textContent.trim();
      const prose = details.querySelector('.sp-info__prose');
      if (!label || !prose) return;
      groups.set(normalize(label),prose);
      prose.querySelectorAll('p').forEach((p) => {
        const lines = p.innerHTML.split(/<br\s*\/?\s*>/i).map((line) => {
          const el = document.createElement('div'); el.innerHTML = line; return el.textContent.trim();
        }).filter(Boolean);
        if (lines[0]) known.add(normalize(lines[0])+'|'+normalize(lines.slice(1).join(' ')));
      });
    });
    let added = 0;
    for (const org of data.organizations) {
      if (typeof org.name !== 'string' || !org.name.trim()) continue;
      const name = org.name.trim();
      const city = String(org.city || '').trim();
      const region = String(org.region || '').trim();
      const country = String(org.country || '').trim();
      const key = normalize(name)+'|'+normalize(city);
      if (known.has(key)) continue;
      known.add(key);
      const label = country === 'United States' ? (region || country) : [region,country].filter(Boolean).join(', ') || source.dataset.otherLocations;
      let prose = groups.get(normalize(label));
      if (!prose) {
        const item = document.createElement('div'); item.setAttribute('data-info-item','');
        const details = document.createElement('details'); details.className='sp-info__detail';
        const summary = document.createElement('summary'); summary.textContent=label;
        prose = document.createElement('div'); prose.className='sp-info__prose';
        details.append(summary,prose);item.append(details);list.append(item);groups.set(normalize(label),prose);
      }
      const p = document.createElement('p'); p.textContent=name;
      if (city) p.append(document.createElement('br'),document.createTextNode(city));
      prose.append(p); added++;
    }
    const sorted = [...list.children].sort((a,b) => (a.querySelector('summary')?.textContent || '').localeCompare(b.querySelector('summary')?.textContent || ''));
    list.append(...sorted);
    root.dataset.charitableAdded=String(added);
    root.dataset.charitableCount=String(data.organizations.length);
  }
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    hydrateCharitable(root);
    root.querySelectorAll('[data-info-toc]').forEach((container) => {
      const source = container.querySelector('[data-info-policy]');
      const list = container.querySelector('[data-info-toc-links]');
      if (!source || !list) return;
      source.querySelectorAll('p').forEach((p) => {
        const text = p.textContent.trim();
        if (text && text.length < 100 && (/^[A-Z\s\d&:().—–-]+$/.test(text) || /^\d[.)]\s/.test(text))) {
          const heading = document.createElement('h2');
          heading.textContent = text;
          p.replaceWith(heading);
        }
      });
      source.querySelectorAll('h1').forEach((heading) => {
        const replacement = document.createElement('h2');
        replacement.innerHTML = heading.innerHTML;
        heading.replaceWith(replacement);
      });
      source.querySelectorAll('h2').forEach((heading, index) => {
        if (!heading.id) heading.id = 'policy-section-' + index;
        const link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent;
        const li = document.createElement('li');
        li.append(link);
        list.append(li);
      });
      if (!list.children.length) container.querySelector('nav').hidden = true;
    });
    const search = root.querySelector('[data-info-search]');
    const items = [...root.querySelectorAll('[data-info-item]')];
    const table = root.querySelector('[data-info-price-table]');
    if (table) {
      const rows = [...table.rows];
      rows.slice(1).forEach((row) => items.push(row));
      if (rows[0]) [...rows[0].cells].forEach((cell) => {
        const th = document.createElement('th');
        th.textContent = cell.textContent;
        th.scope = 'col';
        cell.replaceWith(th);
      });
    }
    let category = 'all';
    const status = root.querySelector('[data-info-status]');
    const reset = root.querySelector('[data-info-reset]');
    const filters = [...root.querySelectorAll('[data-recipe-filter]')];
    function update() {
      const query = (search?.value || '').trim().toLocaleLowerCase();
      let count = 0;
      items.forEach((item) => {
        const show = (!query || item.textContent.toLocaleLowerCase().includes(query)) && (category === 'all' || item.dataset.recipeKind === category);
        item.hidden = !show;
        if (show) count++;
        if (query && show && root.dataset.infoPage === 'donations') item.querySelector('details')?.setAttribute('open','');
      });
      if (status) status.textContent = count ? (query || category !== 'all' ? count + ' ' + root.dataset.results : root.dataset.allResults) : root.dataset.noResults;
      if (reset) reset.hidden = !query && category === 'all';
      filters.forEach((button) => button.setAttribute('aria-pressed',String(button.dataset.recipeFilter === category)));
    }
    search?.addEventListener('input',update);
    filters.forEach((button) => button.addEventListener('click',() => { category = button.dataset.recipeFilter; update(); }));
    reset?.addEventListener('click',() => {if(search)search.value='';category='all';update();search?.focus();});
    if (search) update();
  }
  document.querySelectorAll('[data-info-page]').forEach(init);
  document.addEventListener('shopify:section:load',(event) => event.target.querySelectorAll('[data-info-page]').forEach(init));
})();
